import { ManageProductOptions } from '@airship-platform/airship-proposal';
import Box from '@mui/material/Box';
import { useFormContext } from 'react-hook-form';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';
import { ProposalTemplateOption } from '../../../data-access/proposalTemplate';
import { OptionFormInputs } from '../../proposal-options-manage';

type ProposalTemplateOptionCardProps = {
  proposalTemplateOption: ProposalTemplateOption;
};

const OptionsSelector: React.FC<ProposalTemplateOptionCardProps> = ({
  proposalTemplateOption,
}) => {
  const { options: appointmentOptions, isLoading } =
    useAppointmentProposalOptions();
  const { watch, setValue, getValues } = useFormContext<OptionFormInputs>();
  const optionDefaultNames = watch('names');

  const setSelectedOptionIds = (optionIds: string[]) =>
    setValue(
      'names',
      getValues('names').map((o) => ({
        ...o,
        templateOptionIds: optionIds.includes(o.optionId)
          ? Array.from(
              new Set([
                ...o.templateOptionIds,
                proposalTemplateOption.proposalTemplateOptionId,
              ])
            )
          : o.templateOptionIds.filter(
              (d) => d !== proposalTemplateOption.proposalTemplateOptionId
            ),
      }))
    );

  const optionItems = appointmentOptions.length
    ? appointmentOptions
    : optionDefaultNames.map(({ name, optionId }) => ({
        name,
        appointmentProposalOptionId: optionId,
      }));

  const selectedDefaultIds = optionDefaultNames
    .filter((d) =>
      d.templateOptionIds.includes(
        proposalTemplateOption.proposalTemplateOptionId
      )
    )
    .map((n) => n.optionId);

  return (
    <Box
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.300',
        padding: 2,
        minWidth: ['auto', 'auto', '400px'],
        maxWidth: ['100%', '100%', '500px'],
      }}
    >
      <ManageProductOptions
        options={optionItems}
        isLoading={isLoading}
        selectedOptionIds={selectedDefaultIds}
        setSelectedOptionIds={setSelectedOptionIds}
      />
    </Box>
  );
};

export default OptionsSelector;
